import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, notification } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { UploadOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import _ from "lodash";


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { empleadoReadAction, empleadoConfigurarComisionAction } from '../../../redux/administracion/empleados/actionCreator';

const EmpleadoComisionView = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const registro = useSelector(state => state.EmpleadoReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    if (id)
      dispatch(empleadoReadAction(id));
    else {
      dispatch(empleadoReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      form.setFieldsValue(
        { 
          id: registro.id, 
          porcentaje_comision: registro.porcentaje_comision,
          porcentaje_retencion: registro.porcentaje_retencion,
          porcentaje_retencion_clinica: registro.porcentaje_retencion_clinica,
        });
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const handleSubmit = async (values) => {

    const responseApi = await dispatch(empleadoConfigurarComisionAction(values));
    if (responseApi) {
      let mensaje = 'Configuración realizada exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/recursos-humanos/listado');
    } else {
      notification.error({
        message: 'Error en la configuración',
      });
    }
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/recursos-humanos/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="CONFIGURAR COMISIONES Y RETENCIONES"
        subTitle={<>EMPLEADO: {registro.nombre} {registro.paterno} {registro.materno}</>}
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>                  
                  <BasicFormWrapper>
                    <Form.Item name="id" noStyle>
                      <Input hidden />
                    </Form.Item>
                    <Form.Item name="action" initialValue="comision" noStyle>
                      <Input hidden />
                    </Form.Item>
                    <Form.Item name="porcentaje_comision" label="¿Qué porcentaje bruto de comisión se otorgará a éste empleado?" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="porcentaje_retencion" label="¿Qué porcentaje bruto de retención se aplicará a éste empleado?" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                    <Form.Item name="porcentaje_retencion_clinica" label="¿Qué porcentaje bruto de retención se aplicará a la clinica" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="" />
                    </Form.Item>
                  </BasicFormWrapper>
                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default EmpleadoComisionView;
